<template>
  <v-card scrollable>
        <v-card-title class="primary" pt0>
          <h6 class="white--text">Facturar</h6>
        </v-card-title>
        <v-card-text>
          <v-flex>
            <v-text-field
              @keyup.enter="buscarcliente"
              name="Nit"
              label="Nit"
              v-model="cliente.nit"
              autofocus
            >
           </v-text-field>
          </v-flex>
          <v-flex row>
            <v-text-field
              @keyup.enter="buscarcliente"
              name="Nombre"
              label="Nombre"
              v-model="cliente.nombre"
            >
            </v-text-field>
            <v-text-field
              @keyup.enter="buscarcliente"
              name="Direccion"
              label="Dirección"
              v-model="cliente.direccion"
              >
            </v-text-field>
            <v-text-field
              @keyup.enter="buscarcliente"
              name="Referencia"
              label="Referencia"
              v-model="cliente.referencia"
              >
            </v-text-field>
            <v-text-field
              @keyup.enter="buscarcliente"
              name="Departamento"
              label="Departamento"
              v-model="cliente.departamento"
              >
            </v-text-field>
            <v-text-field
              @keyup.enter="buscarcliente"
              name="Municipio"
              label="Municipio"
              v-model="cliente.municipio"
              >
            </v-text-field>
            <v-flex xs3>
              <v-checkbox v-model="esruta" value="left" label="Es Ruta"></v-checkbox>
            </v-flex>
            <v-flex v-if="esruta">
                  <v-select
                    @keyup.enter="buscarcliente"
                    v-bind:items="dias"
                    v-model="cliente.dia"
                    label="Día"
                    single-line
                    bottom
                  ></v-select>
                  <v-select
                    @keyup.enter="buscarcliente"
                    v-bind:items="semanas"
                    v-model="cliente.semana"
                    label="Semana"
                    single-line
                    bottom
                  ></v-select>
               <v-text-field
                  @keyup.enter="buscarcliente"
                  name="Orden"
                  label="Orden"
                  v-model="cliente.orden"
                  />
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
</template>

<script>
  export default{
    data () {
      return {
        semanas: [{text: 'Semana1', value: 1}, {text: 'Semana2', value: 2},
          {text: 'Semana3', value: 3}, {text: 'Semana4', value: 4}],
        dias: [{text: '1', value: 1}, {text: '2', value: 2}, {text: '3', value: 3}, {text: '4', value: 4},
          {text: '5', value: 5}, {text: '6', value: 6}
        ],
        dia: '',
        semana: '',
        esruta: false
      }
    },
    methods: {
      buscarcliente () {
        if (this.cliente.nit || this.cliente.codigo) {
          if (this.cliente.nombre && this.cliente.direccion && this.searcherror === true) {
            let dato = this.cliente
            if (this.ruta) {
              dato['ruta'] = this.ruta.id
            }
            this.$store.dispatch('crearcliente', dato)
          } else if (this.cliente.nombre && this.cliente.direccion && this.searcherror === false) {
            this.$store.dispatch('crearfactura', this.cliente.id)
          } else { this.$store.dispatch('buscarclientes', this.cliente.nit || this.cliente.codigo) }
        } else if (this.cliente.nombre && this.cliente.direccion) {
          let dato = this.cliente
          if (this.ruta) {
            dato['ruta'] = this.ruta.id
          }
          this.$store.dispatch('crearcliente', dato)
        } else {
          this.$store.commit('actualizarcliente', {'nombre': '', 'direccion': '', 'ruta': ''})
        }
      }
    },
    computed: {
      cliente: function () {
        return this.$store.getters.cliente
      },
      searcherror: function () {
        return this.$store.getters.get_error_searchcliente
      },
      factura: function () {
        return this.$store.getters.factura
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Fcliente.vue?43da6e5c